import { createSlice } from "@reduxjs/toolkit";

const browserDataSlice = createSlice({
  name: "browser",
  initialState: { browserHeight: 0, browserWidth: 0 },
  reducers: {
    getWidth(state, actions) {
      state.browserWidth = actions.payload;
    },
    getHeight(state, actions) {
      state.browserHeight = actions.payload;
    },
  },
});

export const browserDataActions = browserDataSlice.actions;
export default browserDataSlice;
